import { classNameMerger } from '@breetometer/utils';
import type { FC, PropsWithChildren } from 'react';

import BreadCrumbs from '../BreadCrumb';
import type { IContentWrapper } from './ContentWrapper.helpers';

const ContentWrapper: FC<PropsWithChildren<IContentWrapper>> = ({
	hideBreadcrumb = false,
	className,
	children,
	noHome,
	pageTitle,
	activeLinkUrl,
}) => (
	<div className={classNameMerger('content_wrapper bg-primary-500 border-dark-navy', className)}>
		{!hideBreadcrumb && (
			<BreadCrumbs
				noHome={noHome}
				pageTitle={pageTitle}
				activeLinkUrl={activeLinkUrl}
			/>
		)}
		<div className='content_wrapper_body'>{children}</div>
	</div>
);

export default ContentWrapper;
